export const Consts = {
	mY: 18, mX: 38, mZ: 7,
	tile_width: 75,
	tile_height: 100
};

export const STATES = {
	idle: 0,
	run: 1,
	pause: 2,
	freeze: 3
};

export const Backgrounds: Array<{ img: string, name: string, small?: boolean }> = [
	{img: null, name: 'Nenhum'},
	{img: 'bamboo.jpg', name: 'Bambu'},
	{img: 'blueclouds.jpg', name: 'Céu Azul'},
	{img: 'grayclouds.jpg', name: 'Céu Nublado'},
	{img: 'grass-1.jpg', name: 'Grama'},
	{img: 'stones-1.jpg', name: 'Pedras'},
	{img: 'wood.jpg', name: 'Madeira 1'},
	{img: 'wood-grain-1.jpg', name: 'Madeira 2'}
];

export const ImageSets = [
    {id: 'classic', type: 'PNG', name: 'Clássico', url: 'http://star.physics.yale.edu/~ullrich/software/SolitaireMahjong/'},
    {id: 'riichi', type: 'SVG', name: 'Riichi', url: 'https://github.com/FluffyStuff/riichi-mahjong-tiles'},
	{id: 'uni', type: 'SVG', name: 'Uni', url: 'https://commons.wikimedia.org/wiki/Category:Unicode_1F000-1F02F_Mahjong_Tiles_(color)'},
	{id: 'bzhmaddog', type: 'SVG', name: 'Bzhmaddog', url: 'https://github.com/bzhmaddog/html5-mahjong-solitaire/tree/master/res/skins/default/tiles'},
	{id: 'cheshire137', type: 'SVG', name: 'Cheshire', url: 'https://github.com/cheshire137/Mahjong/tree/master/app/assets/images/tiles'},
	{id: 'unib', type: 'SVG', name: 'Black', url: 'https://commons.wikimedia.org/wiki/Category:Unicode_1F000-1F02F_Mahjong_Tiles'},
	{id: 'gleitz', type: 'PNG', name: 'Gleitz', url: 'https://github.com/gleitz/mahjong/tree/master/public/img/tiles'},
	{id: 'recri', type: 'PNG', name: 'Recri', url: 'https://github.com/recri/mahjong'},
	{id: 'open-fruits', type: 'PNG', name: 'Frutas', url: 'https://github.com/xunkar/open-mahjong/tree/master/resources/tiles/fruits'},
	{id: 'picasso', type: 'PNG', name: 'Picasso', url: 'http://star.physics.yale.edu/~ullrich/software/SolitaireMahjong/'},
	{id: 'modern', type: 'PNG', name: 'Moderno', url: 'http://star.physics.yale.edu/~ullrich/software/SolitaireMahjong/'}
];

export const ImageSetDefault = 'classic';

export const TILES = [
	['t_do1', 't_do1', 't_do1', 't_do1'],
	['t_do2', 't_do2', 't_do2', 't_do2'],
	['t_do3', 't_do3', 't_do3', 't_do3'],
	['t_do4', 't_do4', 't_do4', 't_do4'],
	['t_do5', 't_do5', 't_do5', 't_do5'],
	['t_do6', 't_do6', 't_do6', 't_do6'],
	['t_do7', 't_do7', 't_do7', 't_do7'],
	['t_do8', 't_do8', 't_do8', 't_do8'],
	['t_do9', 't_do9', 't_do9', 't_do9'],
	['t_ch1', 't_ch1', 't_ch1', 't_ch1'],
	['t_ch2', 't_ch2', 't_ch2', 't_ch2'],
	['t_ch3', 't_ch3', 't_ch3', 't_ch3'],
	['t_ch4', 't_ch4', 't_ch4', 't_ch4'],
	['t_ch5', 't_ch5', 't_ch5', 't_ch5'],
	['t_ch6', 't_ch6', 't_ch6', 't_ch6'],
	['t_ch7', 't_ch7', 't_ch7', 't_ch7'],
	['t_ch8', 't_ch8', 't_ch8', 't_ch8'],
	['t_ch9', 't_ch9', 't_ch9', 't_ch9'],
	['t_ba1', 't_ba1', 't_ba1', 't_ba1'],
	['t_ba2', 't_ba2', 't_ba2', 't_ba2'],
	['t_ba3', 't_ba3', 't_ba3', 't_ba3'],
	['t_ba4', 't_ba4', 't_ba4', 't_ba4'],
	['t_ba5', 't_ba5', 't_ba5', 't_ba5'],
	['t_ba6', 't_ba6', 't_ba6', 't_ba6'],
	['t_ba7', 't_ba7', 't_ba7', 't_ba7'],
	['t_ba8', 't_ba8', 't_ba8', 't_ba8'],
	['t_ba9', 't_ba9', 't_ba9', 't_ba9'],
	['t_se_spring', 't_se_summer', 't_se_fall', 't_se_winter'],
	['t_wi_north', 't_wi_north', 't_wi_north', 't_wi_north'],
	['t_wi_south', 't_wi_south', 't_wi_south', 't_wi_south'],
	['t_wi_east', 't_wi_east', 't_wi_east', 't_wi_east'],
	['t_wi_west', 't_wi_west', 't_wi_west', 't_wi_west'],
	['t_fl_bamboo', 't_fl_chrysanthemum', 't_fl_orchid', 't_fl_plum'],
	['t_dr_green', 't_dr_green', 't_dr_green', 't_dr_green'],
	['t_dr_white', 't_dr_white', 't_dr_white', 't_dr_white'],
	['t_dr_red', 't_dr_red', 't_dr_red', 't_dr_red']
];

export const TILES_INFO = {
	suits: [
		{
			name: 'Círculos', tiles: [
				{name: 'Pérola', char: 'Chu', img: 't_do1'},
				{name: 'Pinheiro', char: 'Sung', img: 't_do2'},
				{name: 'Fênix', char: 'Feng', img: 't_do3'},
				{name: 'Jade', char: 'Yü', img: 't_do4'},
				{name: 'Dragão', char: 'Lung', img: 't_do5'},
				{name: 'Pêssego', char: 'Tao', img: 't_do6'},
				{name: 'Inseto', char: 'Ch\'ung', img: 't_do7'},
				{name: 'Tigre Branco', char: 'Hu', img: 't_do8'},
				{name: 'Unicórnio', char: 'Ch\'i', img: 't_do9'}
			]
		}, {
			name: 'Bambu', tiles: [
				{name: 'Pavão', char: 'K\'ung', img: 't_ba1'},
				{name: 'Pato', char: 'Ya', img: 't_ba2'},
				{name: 'Sapo', char: 'Min', img: 't_ba3'},
				{name: 'Carpa', char: 'Li', img: 't_ba4'},
				{name: 'Flor de Lotus', char: 'Lien', img: 't_ba5'},
				{name: 'Água', char: 'Shui', img: 't_ba6'},
				{name: 'Tartaruga', char: 'Kuei', img: 't_ba7'},
				{name: 'Cogumelo', char: 'Chün', img: 't_ba8'},
				{name: 'Salgueiro', char: 'Liu', img: 't_ba9'}
			]
		}, {
			name: 'Caractéres', tiles: [
				{name: 'Barra', char: 'Ju', img: 't_ch1'},
				{name: 'Espada', char: 'Chien', img: 't_ch2'},
				{name: 'Terra', char: 'Ti', img: 't_ch3'},
				{name: 'Alaúde', char: 'Ch\'in', img: 't_ch4'},
				{name: 'Casa', char: 'Fang', img: 't_ch5'},
				{name: 'Fogo', char: 'Huo', img: 't_ch6'},
				{name: 'Sete Estrelas', char: 'Tuo', img: 't_ch7'},
				{name: 'Laço', char: 'Chieh', img: 't_ch8'},
				{name: 'Céu', char: 'Tien', img: 't_ch9'}
			]
		}
	],

	bonus: [
		{
			name: 'Estações', tiles: [
				{name: 'Primavera', char: 'Yu', img: 't_se_spring'},
				{name: 'Verão', char: 'Ch\'iao', img: 't_se_summer'},
				{name: 'Outono', char: 'Keng', img: 't_se_fall'},
				{name: 'Inverno', char: 'Tu', img: 't_se_winter'},
			]
		},
		{
			name: 'Flores', tiles: [
				{name: 'Bambu', char: 'Chu', img: 't_fl_bamboo'},
				{name: 'Orquídea', char: 'Lan', img: 't_fl_orchid'},
				{name: 'Ameixa', char: 'Li', img: 't_fl_plum'},
				{name: 'Crisântemo', char: 'Chü', img: 't_fl_chrysanthemum'}]
		}
	],

	honors: [
		{
			name: 'Ventos', tiles: [
				{name: 'Leste', char: 'Tung', img: 't_wi_east'},
				{name: 'Sul', char: 'Nan', img: 't_wi_south'},
				{name: 'Oeste', char: 'Hsi', img: 't_wi_west'},
				{name: 'Norte', char: 'Pei', img: 't_wi_north'}]
		},
		{
			name: 'Dragões', tiles: [
				{name: 'Vermelho', char: 'Chung', img: 't_dr_red'},
				{name: 'Verde', char: 'Fa', img: 't_dr_green'},
				{name: 'Branco', char: 'Pai', img: 't_dr_white'}]
		}
	]
};
